// 商品详情界面

<template>
  <div class="product-detail-container">
    <div class="product-detail-content" v-html="productDetail"></div>
  </div>
</template>
<script>
  import {getSessionCache} from '../utils'

export default {
  name: 'productDetail',
  data(){
    return {
      productDetail: ''
    }
  },
  mounted(){
    let productDetail = getSessionCache('productDetail')
    if (productDetail) {
      this.productDetail = productDetail
    } else {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss">
  .product-detail-container{
    .product-detail-content{
      font-size: 36px;
      img{
        width: 100%;
        display: block;
      }
    }
  }
</style>